import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const projectId = localStorage.getItem('currentProjectId');
  if (projectId) config.headers['X-Project-Id'] = projectId;
  return config;
});

const conversationService = {
  async list({ page = 1, limit = 25, filter } = {}) {
    const { data } = await api.get('/conversations', { params: { page, limit, filter } });
    return data.data;
  },

  async get(id) {
    const { data } = await api.get(`/conversations/${id}`);
    return data.data;
  },

  /** Send the drafted reply, with any edits the reviewer made. */
  async approve(id, { subject, text } = {}) {
    const { data } = await api.post(`/conversations/${id}/approve`, { subject, text });
    return data.data;
  },

  /** Write and send a reply by hand. Pauses autopilot on that thread. */
  async reply(id, { subject, text }) {
    const { data } = await api.post(`/conversations/${id}/reply`, { subject, text });
    return data.data;
  },

  async discard(id) {
    await api.post(`/conversations/${id}/discard`);
  },

  async setAutopilot(id, paused) {
    const { data } = await api.post(`/conversations/${id}/autopilot`, { paused });
    return data.data;
  },

  async resolve(id) {
    await api.post(`/conversations/${id}/resolve`);
  }
};

export default conversationService;
